var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EEFDF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.5C18.2091 16.5 20 14.7091 20 12.5C20 10.2909 18.2091 8.5 16 8.5C13.7909 8.5 12 10.2909 12 12.5C12 14.7091 13.7909 16.5 16 16.5Z",
    stroke: "#4AF06F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23.5V21.1667C22 19.929 21.6839 18.742 21.1213 17.8668C20.5587 16.9917 19.7956 16.5 19 16.5H13C12.2044 16.5 11.4413 16.9917 10.8787 17.8668C10.3161 18.742 10 19.929 10 21.1667V23.5",
    stroke: "#4AF06F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserArt);
export default __webpack_public_path__ + "static/media/userArt.71259c2e1cbca9df9da2726cdf31717b.svg";
export { ForwardRef as ReactComponent };